import type { PracticalProject } from "../../data";

export const todo: PracticalProject = {
  id: "todo",
  num: 0,
  title: "実践プロジェクト0 TODOアプリ — 完成したコードを読んで、Webアプリの全体を知る",
  description:
    "完成した TODO アプリのコードを読み、React から HTTP Handler、Repository、PostgreSQL までの流れと、匿名 Cookie によるデータ分離を理解する",
  duration: "1〜2 時間",
  techStack: ["TypeScript", "React", "Node.js", "Express", "PostgreSQL"],
  difficulty: "beginner",
  phase: "Phase 3 後半",
  // 画面と API を1つにした Cloud Run の見本。作り方は tools/practical/todo-demo/deploy.sh
  // ページに埋め込んでも匿名 Cookie (SameSite=Lax) が届くよう、yumesaku.tech のサブドメインから中継する。
  // 中継の Worker は tools/practical/demo-proxy
  demoUrls: {
    typescript: "https://pj-todo-typescript.yumesaku.tech",
    go: "https://pj-todo-go.yumesaku.tech",
    java: "https://pj-todo-java.yumesaku.tech",
    python: "https://pj-todo-python.yumesaku.tech",
  },
  demoEmbed: true,
  learningOutcomes: [
    "React から HTTP Handler、Repository、PostgreSQL へ処理が進む流れを説明できる",
    "匿名 Cookie でブラウザごとに TODO を分離する方法と、その制約を理解する",
    "画面、API、入力スキーマ、SQL の担当箇所をコードから見つけられる",
  ],
  chapters: [{ num: 1, title: "はじめに" }],
};
